import { Tabs } from "@mantine/core"
import { DataFetchWrapper, InfoBox, Loader } from "@tfg/ui"
import { useState } from "react"

import { CertificateTypesWrapper } from "./Certiicates"
import { Standards } from "./Standards/Standards"
import {
  useListCertificateTypesQuery,
  useStandardsQuery,
} from "./Standards/hooks"

export const CertificatesTypesAdminWrapper = () => {
  const standardsQuery = useStandardsQuery()
  const {
    data: certificateTypesList,
    isLoading,
    isError,
  } = useListCertificateTypesQuery()
  const [tab, setTab] = useState<string>("standards")

  if (isLoading) {
    return <Loader fullPage />
  } else if (isError) {
    return <InfoBox title="Error" message="Failed to load data" />
  } else {
    return (
      <>
        <Tabs value={tab} onChange={(value) => setTab(value ? value : "")}>
          <Tabs.List>
            <Tabs.Tab key="standards" value="standards">
              Standards
            </Tabs.Tab>
            <Tabs.Tab key="certificates" value="certificates">
              Certificates
            </Tabs.Tab>
          </Tabs.List>
          <Tabs.Panel value="standards">
            {tab === "standards" ? (
              <DataFetchWrapper query={standardsQuery}>
                {({ data }) => (
                  <Standards
                    standards={data}
                    certificatesTypesList={certificateTypesList}
                  />
                )}
              </DataFetchWrapper>
            ) : null}
          </Tabs.Panel>
          <Tabs.Panel value="certificates">
            {tab === "certificates" ? <CertificateTypesWrapper /> : null}
          </Tabs.Panel>
        </Tabs>
      </>
    )
  }
}
